<template>
  <div>
    <SensorMenuTop />
    <SensorMap />
    <!-- <br> -->
    <!-- <SensorStatistics /> -->
    <SensorChart />
    <!-- <br> -->
    <SensorTable />
  </div>
</template>

<script>
import SensorMap from '@/views/sensor/lux/total/SensorLuxMap.vue'
// import SensorStatistics from '@/views/sensor/total/SensorStatistics.vue'
// import SensorRTSP from '@/views/sensor/total/SensorRTSP.vue'
import SensorTable from '@/views/sensor/lux/total/SensorLuxTable.vue'
import SensorMenuTop from '@/views/sensor/lux/total/SensorLuxMenuTop.vue'
import SensorChart from '@/views/sensor/lux/total/SensorLuxChart.vue'
// import axios from '@axios'
export default {
  components: {
    SensorMap,
    // SensorStatistics,
    // SensorRTSP,
    SensorTable,
    SensorMenuTop,
    SensorChart,
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  },
}
</script>

  <style>
  </style>
